export default {
    //dealmanagement
    dealmanagement:{
        aftersalesManagement:{
            aftersalesManagement:'After-sales management',
            orderNo:'After-sales number',
            associatedOrderNumber:'Associated Order Number',
            afterSingleType:"After-sales single type",
            orderSourceList:"Original order Source",
            creationDate:"Creation time",
            skuCode:"Product Code",
            SkuName:"Product Name",
            refundStatus:"After-Sales order status",
            channelName:"Store Name",
            skuSeriaLno:"Product Serial Code",
            storeOrderInformation:"Store after-sales order information",
            relationOrderNo:'Sales Tracking Number',
            orderSource:"Order origin",
            refundQty:"Number of returns",
            refundMoney:"Total Refund Amount",
            consumerName:"Consumer Name",
            consumerPhone:"Consumer Phone",
            retailerName:"Retailer Name",
            createdBy:'Create person',
            afterOrderDetails:"After-Sales order Details",

            afterOrderInformation:"After-Sales order information",
            ChannelCode:"Store code",
            iretailCode:"Store Iretail Code:",
            retailerCode:"Retailer Code",
            CustomerCode:"Retailer PRM Code:",
            productInformation:"Product Information",
            onlinePayment:"On-line Payment",
            offlinePayment:"Off-line Payment",
            lightWeightPlatform:"Light weight Platform",
            smallProgram:"Small program",
            Unionpay:"Unionpay",
            Alipay:"Alipay",
            wechat:"Wechat",
            cash:"Cash",
            supplierShortName:"Suppliers",
            SerialNo:"Serial Code",
            typeCode:"Product Type",
            virtualGoods:"Virtual Goods",
            physicalGoods:"Physical goods",
            codeAssociatedCommodity:"Serial code associated with the equity commodity",
            replacementQuantity:'Return and Replacement quantity',
            refundMoneys:"Refund Amount",
            retailPrice:"Suggested Retail price",
            salePrice:"Retail price",
            totalLineAmount:"Total line Amount",
            lineDelivery:"line is paid",
        },
        ordermonitor:{
            pushMonitoring:"Push monitoring",
            orderNumber:"Order number",
            shopGroup:"Shop Group" ,
            shopName:"Shop Name",
            executionEvents:"Execution events",
            executionResults:"Execution results",
            storeCode:"Store code",
            lastExecutionTime:"Last Execution time",
            numberOfExecutions:"Number of executions",
            executionNoEmpty:"The execution event cannot be empty",
            orderNoEmpty:"The order type cannot be empty",
            executionsNoEmpty:"The number of executions cannot be empty",
            executionsNotEmpty :"The number of executions cannot be empty",
            salesPushIdeal:"Sales order Push Ideal",
            salesPushEFA:"Sales Order Push EFA",
            modifyExecutions:"Modify the number of executions",
            upperBody:"Upper body",
            channelCode:"Store code",
            limitCount:"Number of executions",
            lastUpdateDate:"Last Execution time",
            orderDetails:"Order Details",
            monitoringConfiguration:"Monitoring Configuration",
            orderType:"Order type",
            shopPaymentOrder:"Shop Offline Payment Order",
            vendorSalesOrder:"Vendor Sales Order",
            exchangeOrders:"Exchange Orders",
            returnOrder:"Return Order",
            pushMonitoringInformation:"Push monitoring information",
            manuallyModifyExecutions:"Manually modify the number of executions",
            pushMonitoringList:"Push monitoring List",
            editExecutionCount:"Edit Execution Count",
            newConfiguration:"New configuration",
            deleteConfigurationItem:"Delete a configuration item"
        },
        retailordermanage:{
            orderNumber:"Order number",
            creationTime:"Creation time",
            paymentTime:"Payment Time",
            orderType:"Order type",
            orderSource:"Order origin",
            customNo:"Custom Order Number",
            retailerName:"Retailer Name",
            retailerCode:"Retailer Code",
            consumerName:"Consumer Name",
            channelName:"Store Name",
            channelCode:"Store code",
            channelIretailCode:"Store Retail Code",
            consumerPhone:"Consumer Phone",
            createdBy:"Create a single",
            salesName:"Promotional Staff",
            paymentType:"Payment type",
            paymentChannel:"Payment Methods",
            paymentDate:"Payment Time",
            totalMoney:"Total Order Amount",
            discountMoney:"Total discount Amount",
            paymentMoney:"Amount paid",
            couponCode:"Coupon code",
            couponMoney:"Coupon Amount",
            currency:"Currency type",
            logisticsCompany:"Logistics company",
            logisticsBillNo:"Logistics Tracking Number",
            consigneeName:"Recipient",
            consigneePhone:"Recipient Phone",
            consigneeAddres:"Shipping Address",
            onlinePayment:"On-line Payment",
            offlinePayment:"Off-line Payment",
            lightWeightPlatform:"Light weight Platform",
            smallProgram:"Small program",
            Unionpay:"Unionpay",
            Alipay:"Alipay",
            wechat:"Wechat",
            cash:"Cash",
            skuName:"Product Name",
            skuCode:"Product Code",
            spuName:"SPU Product Name",
            spuCode:"SPU encoding",
            typeCode:"Product Type",
            virtualGoods:"Virtual Goods",
            physicalGoods:"Physical goods",
            supplierShortName:"Suppliers",
            skuSerialNo:"Serial Code",
            relationId:"Products that use benefits",
            refundQty:"Number returned",
            refundMoney:"Refund Amount",
            retailPrice:"Suggested Retail price",
            salePrice:"Retail price",
            buyQty:"Product Quantity",
            totalLineAmount:"Total line Amount",
            bankOffers:"Bank offers",
            lineDelivery:"Line delivery",
            storeRetailManagement:"Store Retail Order Management",
            retailOrderNumber:"Retail Order Number",
            productName:"Product Name",
            orderStatusList:"Order Status",
            paymentStatusList:"Payment status",
            createTime:"Creation time",
            startTime:"Start time",
            endTime:"End time",
            payTime:"Payment Time",
            moreQueryCriteria:"More query criteria",
            refundStatusList:"Return and Exchange status",
            isUseCoupon:"Whether to use coupons",
            skuSeriaL:"Product Serial Code",
            consumerPhone:"Consumer Phone",
            consumerName:"Consumer Name",
            orderNo:"Retail Waybill",
            discountMoney:'Order Discount Amount',
            paymentMoney:'Amount paid',
            paymentStatus:'Payment status',
            notPaid:"Not paid",
            partialPayment:"Partial payment",
            paymentSuccess:"Payment success",
            paymentException:"Payment exception",
            orderStatus:'Order Status',
            pendingReview:"Pending review",
            auditThrough:"Audit through",
            auditNotPass:"Audit does not pass",
            pendingDelivery:"Pending delivery",
            partialShipment:'Partial Shipment',
            alreadyShipped:"Already shipped",
            signed:"has been signed",
            transactionCompletion:"Transaction completion",
            transactionCancellation:"Transaction cancellation",
            hasBeenCanceled:"has been canceled",
            refundStatus:'Return and Exchange status',
            nonExchange:"Non-return Exchange",
            partialReturns:"Partial returns",
            returnComplete:"return complete",
            partialExchange:"Partial Exchange",
            exchangeComplete:"Exchange complete",
            refundMoney:"Refund Amount",
            createdBy:"Create person",
            not:"Whether",
            yes:"Is",
            retailerName:"Retailer Name",
            listDetail:"Order Details",
            orderInformation:"Order Information",
            retailOrderInformation:"Purchase order List"
        },
        supplierorder:{
            vendorManagement:"Vendor Sales Order Management",
            orderNo:"Order number",
            subjectName:"Supplier name",
            skuCode:"Product Code",
            createTime:"Creation time",
            startTime:'Start time',
            endTime:'End time',
            skuName:"Product Name",
            retailerCode:"Retailer Code",
            payTime:"Payment Time",
            executeIdealResult:"Push Ideal Status",
            executeSupplierResult:"Push supplier status",
            orderStatusArray:"Order Status",
            paymentStatusArray:"Payment status",
            retailerName:"Retailer Name",
            orderSourceNo:"Purchase number",
            shippingInformationImport:"Shipping Information Import",
            uploadingFiles:"Uploading files",
            signInformationImport:'Sign-in Information import',
            viewContract:"View contract",
            orderDetails:"Order Details",
            totalMoney:"Total Order Amount",
            discountMoney:"Offer Amount",
            paymentMoney:"Amount paid",
            orderType:"Order type",
            orderSource:"Order origin",
            logisticsCompany:"Waybill number",
            deliveryTime:"Delivery time",
            receivTime:"Receipt Time",
            subjectNam:"Suppliers",
            salesContract:"Sales Contract",
            paymentType:"Payment type",
            paymentChannel:"Payment Methods",
            payMoney:"Amount paid",
            priceConfirmed:"Real-Bank Price guarantee",
            delayIncentive:"Delayed excitation",
            exceptionActivateList:"Exception activates data import list",
            activityInfoConfig:"Activity  info config",
            currency:"Currency type",
            invoiceType:"Invoice type",
            titleType:"Invoice Header Type",
            titleName:"Invoice Header",
            taxpayerId:"Taxpayer Identification number",
            logisticsCompanyNo:'Logistics company',
            logisticsBillNo:"Logistics Tracking Number",
            consigneeName:"Recipient",
            consigneePhone:"Recipient Phone",
            consigneeAddress:"Shipping Address",
            skuName:'Product Name',
            skuCode:"Product Code",
            typeCode:"Product Type",
            supplierShortName:"Suppliers",
            salePrice:"Price",
            buyQty:"Product Quantity",
            totalLineMoney:"Total line Amount",
            signingTime:"Sign Time",
            party:"Party",
            contactName:"Contact",
            address:"Address",
            contactPhone:"Phone",
            square:"Party b",
            agreement:"The Parties shall, through friendly negotiation, procure the following products from party a",
            agreementOne:"First, the product, quantity and amount of supply",
            settlementMethod:"Settlement method",
            paymentMethod:"Payment method",
            countName:"User name",
            countBank:"Bank Account",
            countNumber:"Account",
            platformSkuName:"Products",
            qty:"Quantity (SET)",
            color:"Color",
            unitPrice:"Price including tax (RMB)",
            rowPrice:"Total Amount (yuan)",
            auditInformation:'Audit Information',
            logisticsCarrier:"Logistics Carrier",
            orderInformation:"Order Information",
            paymentInformation:"Payment information",
            invoicingInformation:'Invoicing information',
            logisticsInformation:"Logistics information"
        },
    },
    //finance
    finance:{
        basecfg:{
            invoiceConfiguration:"Invoice configuration",
            operationSucceeded:"Operation succeeded",
            classifyName:"Preferential payment Ratio",
            single:"Per order",
            status:"Effective",
            classifyDesc:"Financial Module Type",
            invoiceConfigurationInformation:"Invoice configuration information",
            propertyInformationTable:"Property Configuration Information Table",
        },
        customerICBC:{
            ICBCAccount:"ICBC Account List",
            refreshBalance:"Refresh Balance",
            details:"Detail Query",
            recent:"Recent",
            week:"A week",
            month:'One month',
            year:'One year',
            monthChoose:"Select by month",
            orderPurchase:"Order Purchase",
            accountRecharge:"Account Recharge",
            accountList:"Account List",
            tradingInformation:"List of trading information",
        },
        fundAccountManage:{
            paymentAccountInformation:"Third-party Payment account information",
            bankAccount:"Bank Account",
            receivingParty:"Receiving party",
            paymentParty:"Payment Party",
            yuanPercent:'Yuan/single',
            organizationNoEmpty:"The organization name cannot be empty",
            accountNotEmpty:"Account cannot be empty",
            fundAccountList:"Fund Account List",
            editAccountDetails:"Edit Account Details",
            tradingInformation:"Trading information",
            enable:"Enable",
            disable:"Disable",
            transactions:"Transaction details",
            accountType:"Account Type",
            accountInformation:"Account information",
            interfaceInformation:"Interface information",
            rateInformation:"Rate information",
            contractInformation:"Contract information"
        },
        fundReport:{
            classificationDetails:"Balance Classification Details",
            priceGuarantee:"Real-Bank Price guarantee",
            temporaryIncentives:"Temporary incentives",
            subAccount:"Sub Account",
            today:'Today',
            yesterday:"Yesterday",
            weekAgo:'One weeks ago',
            weekNear:'Last week',
            nearMonth:'Last one months',
            nearYear:'Last year',
            supplierShortName:"Suppliers",
            businessType:"Type of Business",
            businessNo:"Business Number",
            changeTime:"Date of Occurrence",
            tempDiscount:'Temporary incentives',
            bankBalance:"ICBC Account",
            fundBalance:"Balance of funds in account",
            balanceAccount:"Balance sheet of funds in account",
            yearMonth:"Years",
            details:'Bill of funds in account',
            near:'Recent',
            week:'A week',
            month:'One month',
            year:'One year',
            monthChoose:"Select by month",
            orderPurchase:'Order Purchase',
            accountRecharge:'Account Recharge',
            incentiveImport:"Incentive Import",
            chooseYearMonth:"Choose the Month",
            fundsBalancesAccount:"List of funds balances in the account",
            listFundsBalances:'List of funds balances in the account',
        },
        incentiveImport:{
            priceGuarantee:"Real-Bank Price guarantee",
            temporaryIncentives:"Temporary incentives",
            incentiveImportList:"Incentive Import List",
            importTemplateUpload:'Incentive Import Template Upload',
            templateDownload:"Template download",
            pendingReview:"Pending review",
            auditThrough:"Audit through",
            auditNotPass:"Audit does not pass",
            operationHistory:'Operation History',
            operation:'Resume',
            details:'Details',
            audit:'Audit',
            importTracking:"Import tracking Number",
            importSuccess:"Import succeeded",
            incentiveImport:"Incentive Import",
            auditOpinion:"Audit opinion" ,
        },
        bill:{
            supplierShortName:'Invoice body',
            billType:'Invoice type',
            defaultType:'Default Type',
            defaultRise:'Default Header',
            classifyName:'Preferential payment Ratio'
        },
        capital:{
            supplierShortName:'Supplier abbreviation',
            accountType:'Account Type',
            accountUnit:'Account Opening Unit',
            organization:'Name of Institution',
            bankName:'Name of the depositary bank',
            accountNo:'Account',
            channelGroupCode:'Store group code',
            channelGroupName:'Name of the store group',
            payType:'Payment method',
            status:'State',
            openDateString:'Opening hours',
            usedFlag:'is enabled',
            partnerPid:'Partner identity',
            securityKey:'Security Check Code',
            serviceChargeDuty:'Handling fee of the responsible party',
            serviceChargeWay:'How to pay the handling fee',
            fixedCharge:'At a fixed fee',
            ratioCharge:'Prorated charges',
            contract:'Retailer Purchase Contract Name',
            remark:'Retailer Purchase Contract Notes',
            businessDirection:'Business direction',
        },
        retailer:{
            serialNo:'Trade Serial Number',
            retailerId:'Retailer ID',
            retailerName:'Retailer Name',
            supplierId:'Vendor ID',
            supplierShortName:'Supplier abbreviation',
            accountName:'Account name',
            accountNo:'ICBC Account',
            bankNo:'Bank account Number',
            bankName:'Name of the depositary bank',
            openDate:'Opening date',
            balance:'Balance (yuan)',
            currtype:'Currency type',
            idtype:'Voucher Type',
            idNo:'ID number',
            relatedAccountNo:'Associated Master Account',
            relatedAccountName:'Master account name',
            relatedBankNo:'Main account associated Bank line number',
            relatedBankName:'Main account Associated Bank name',
            firstBalance:'Opening balances',
            changeBalance:'Amount of Occurrence',
            lastBalance:'Closing balance',
            businessNo:'Business serial Number',
            relatedBusiness:'Related business',
            rcAccountNo:'Beneficiary Account',
            rcAccountName:'Beneficiary Account Name',
            rcBankNo:'Beneficiary Account Bank Line number',
            rcBankName:'Beneficiary Account Bank Name',
            changeTime:'Time of Occurrence',
        },
        discount:{
            impNo:'Import tracking Number',
            calculateTime:'Settlement time',
            impTime:'Import time',
            impOperator:'Importing people',
            approvaler:'Approving person',
            remark:'Remarks (Approval comments)',
            approvalStatus:'Approval Status',
            disNo:'Incentive ticket',
            disIndex:'Excitation serial number',
            disType:'Type of incentive',
            customerId:'Customer ID',
            contract:'Joint issue',
            channelName:'Shop Name',
            deptname:'Department',
            retailerId:'Retailer ID',
            retailerCode:'Retailer Code',
            retailerName:'Retailer Name',
            spuModel:'Product model',
            skuName:'Product Name',
            skuCode:'SKU Code',
            unitPrice:'Single-Station excitation',
            qty:'Number of incentives',
            totalPrice:'Incentive Amount',
            calculateTime:'Settlement time',
            avlBalance:'Available Amount',
            supplierId:'Vendor ID',
            supplierShortName:'Supplier abbreviation',
            operations:'Operation',
            createdBy:'Create person',
            creationDate:'Operating time',
            results:'Results'
        },
        fund:{
            retailerId:'Retailer ID',
            retailerName:'Retailer Name',
            fundType:'Type of funds',
            firstBalance:'Opening balances',
            inBalance:'Income',
            outBalance:'Spending',
            lastBalance:'Closing balance',
            supplierId:'Vendor ID',
            supplierShortName:'Supplier abbreviation',
            supplier:'Suppliers',
            yearMonth:'Years',
            businessType:'Type of Business',
            businessId:'Business Order ID',
            businessNo:'Business Number',
            changeTime:'Time of Occurrence',
            startDate:'Start time',
            endDate:'End time',
            changeMoney:'Amount incurred',
            protectPrice:'Real-Bank Price guarantee',
            tempDiscount:'Temporary incentives',
            bankBalance:'ICBC System Balance',
            fundBalance:'Balance of funds in account',
            tolProtectPrice:'Latest real-Bank price guarantee Total',
            tolTempDiscount:'Latest temporary Incentive Total'
        },
        fundDetails:{
            bankBalance:'ICBC Account',
        },
        refund:{
            serialNo:'Flow number',
            outTradeNo:'Order number',
            afterSaleNo:'After-Sales order number',
            refundNo:'Refund number',
            totalFee:'Total amount of order payment',
            refundFee:'Refund Amount',
            payType:'Refund Type',
            payWay:'Refund method',
            payState:'Refund Status',
            consumer:'Name of consumer',
            retailerName:'Retailer Name',
            channelName:'Shop Name',
            orderSource:'Order source',
            modifyState:'Modify refund Slip Status',
            bigDecimalModificationNum:'Record version number',
            createdBy:'Create a person',
            creationDate:'Creation time',

            orderNo:'Order number',
            orderType:'Order type',
            customNo:'Custom single number',
            iretailCode:'Store Iretail encoding',
            retailerCode:'Retailer coding',
            channelId:'Shop coding',
            salesName:'Name of promoter',
            consumerName:'Name of consumer',
            consumerPhone:'Consumer Phone',
            paymentType:'Payment type',
            paymentChannel:'Payment Channels',
            totalMoney:'Total Order Amount',
            discountMoney:'Total amount of Offer',
            paymentMoney:'Amount paid',
            currency:'Accounting currency',
            couponMoney:'Coupon Denomination',
            couponCode:'Coupon code',
            logisticsCompany:'Logistics company',
            logisticsBillNo:'Logistics Single Number',
            consigneeName:'Name of consignee',
            consigneePhone:'Consignee Telephone',
            consigneeAddres:'Shipping Address',

            paymentDate:'Payment Time',
            creationDate:'Creation time',
            skuCode:'Product coding',
            skuName:'Product Name',
            typeCode:'Product Type',
            supplierShortName:'Supplier abbreviation',
            skuSerialNo:'Product Serial Code',
            relationId:'Related Equity goods',
            refundQty:'Number of returns',
            refundMoney:'Refund Amount',
            retailPrice:'Suggested Retail price',
            salePrice:'Sales price',
            buyQty:'Quantity purchased',
            totalMoney:'Total amount of rows',
            discountMoney:'Line offer Amount',
            paymentMoney:'Line paid Amount',

            //退款单页面
            refundBatchNo:'Refund number',
            saleOrderNo:'Sales Single number',
            afterSaleOrderNo:'After-sales single number',
            tradementNo:'Trade Flow Number',
            refundAmount:'Refund Amount',
            saleOrderSource:'Order source',
            refundStatus:'Refund Status',
            failCause:'Reason for failure',
            refundChannel:'Payment type',

        },
        refunde:{
            createdBy:'Chuang Solo',
            orderNo:'After-sales single number',
            afterSalesTypeList:'After-Sales type',
            orderStatusList:'Order Status',
            refundStatus:'Return status',
            orderSourceList:'Order source',

        },
        sale:{
            channelName:'Shop Name',
            orderNo:'After-sales single number',
            afterSalesType:'After-Sales type',
            skuCode:'Product coding',
            skuName:'Product Name',
            orderStatus:'Order Status',
            refundQty:'Redemption Quantity',
            orderSource:'Order source',
            refundMoney:'Refund Amount',
            consumerName:'Name of consumer',
            consumerPhone:'Consumer Phone',
            createdBy:'Create a person',
            creationDate:'Creation time',
            relationOrderNo:'Sales Single number',
            refundStatus:'Return status'

        }
    }, 
    home:{
        msg:"Welcome to the Hononer light weight Platform Job Center",
        msgLog:'Sorry, you do not have permission to the operating system, please login again!',
        back:'will automatically exit after seconds',
        directBack:'Direct exit'
    },
    //inventory
    inventory:{
        inventoryManage:{
            inCode:"Inbound number",
            inType:"Warehousing order Type",
            inStatus:"Inbound Order Status",
            subjectType:"Principal type",
            subjectName:"Principal Name",
            supplierShortName:"Supplier name",
            retailerName:"Retailer Name",
            warehouseName:"Inbound Warehouse Name",
            skuCode:"Product Code",
            skuName:"Product Name",
            inNum:"Inbound Quantity",
            actualInNum:"Actual Storage Quantity",
            orderNo:"Source Tracking Number",
            createdBy:"Create person",
            creationDate:"Creation time",
            creationEndDate:'Create End time',

            outCode:"Out of Stock Number",
            outType:"Type of outbound order",
            outStatus:"Out of stock order status",
            numberConfirm:"Number of outbound libraries",
            warehouseType:"Warehouse Type",

            transitNum:"Quantity purchased in transit",
            actualInvNum:"Actual inventory quantity",
            reserveInvNum:"Reserved inventory quantity",
            availableInvNum:"Inventory Quantity available for sale",
            sellTransitNum:"Sales in Transit quantity",

            inWarehouseTime:"Storage time",
            ifShowPhone:"Whether the demo machine",
            serialNumber:"Serial Code",
            statusCode:"Serial Code Status",
            snapshotCode:"Snapshot number",
            snapshotStartTime:"Snapshot start time",
            snapshotEndTime:"Snapshot End Time",
            channelName:'Stores',
            //new cfg
            inventoryInquiry:"Inventory Inquiry",
            stockSnapshot:"Stock Snapshot",
            download:"Download",
            productCodeInformation:"Product Serial Code Information",
            inventoryChanges:"Inventory changes",
            queryLibraryCode:"Query in library string code",
            serialOutRecords:"Serial code out of storage records",
            serialCodeInformation:"Serial Code Information",
            snapshotInformation:"Inventory snapshot Information",
            CodeInformation:"Inventory Serial Code Information",
            accessRecordInformation:'Serial Code access record information',
            creationStartDate:"Snapshot Time"
        },
        storageManage:{
            warehousingManagement:"Warehousing Management",
            inboundDetails:"Inbound Details",
            inboundInformation:'Inbound information'
        },
        warehouseManage:{
            outLibraryManagement:'Out-of-Library management',
            outStockDetails:"Out-of-stock details",
            OutofInformation:"Out-of-Library information",
        },
        out:{
            warehouseName:"Warehouse Name"
        },
        inquire:{
            warehouseName:"Warehouse Name"
        }
    },
    //marketing
    marketing:{
        activityManage:{
            chooseArea:"Select Region",
            activityName:"Activity name",
            limitAmount:"Number of registrations" ,
            noLimitStores:"No limit on number of stores",
            limit:"Limit",
            storeRegistration:"Store Registration",
            channelShareRate:"Registration criteria",
            storeBearsCoupons:"Store bears Coupons",
            RMB:"RMB (The coupon amount has been issued in the actual quantity)",
            selectProduct:'Select a product',
            registrationTime:"Registration time",
            activityStartTime:"Event time",
            eventDescription:'Event description',
            enterActivity:'Please enter an activity name',
            enterActivityLimit:"Please enter the activity name (within 30 characters)",
            enterNumber:'Please enter a positive integer (within 6 digits)!',
            enterStoreProporition:'Please enter the store to bear the proportion',
            withinNumber:'Please enter the number within 0-100!',
            timeNoEmpety:"Time cannot be empty",
            doNot:"Please do not enter special characters! (30 characters or less)",
            enterPositiveInteger:"Please enter a positive integer (within 10 digits)!",
            entryActivityDescription:"Please enter the activity description",
            pleaseSelectRegion:"Please select a region",
            enterLimit:"Please enter (within 30 digits)!",
            delete:"Delete",
            viewRegion:"View the region",
            alreadyEnrolled:"Already enrolled",
            store:"Home",
            productRange:'Product range',
            allProducts:'All Products',
            designatedProducts:"Designated products",
            merchantsCouponRatio:'Merchants bear the coupon ratio',
            couponMoney:"Coupon Amount",
            lastUpdateDate:"Operating time",
            auditFailure:"Audit failure",
            parentSubjectName:"Retailer/Supplier",
            applyStatus:"Audit status",
            channelCode:'Store code',
            channelName:'Store Name',
            provinceName:'Provinces',
            cityName:"City",
            seeWhy:"See why",
            voucherStatus:"Voucher status",
            auditThrough:"Audit through",
            activityHasEnded:"Activity has ended",
            activityPaused:"Activity is paused",
            activitiesInProgress:"Activities in progress",
            activityNotStarted:"Activity not started",
            unlimitedQuantity:"Unlimited quantity",
            pendingReview:'Pending review',
            listMarketingActivities:"List of marketing activities",
            activityStatus:"Activity status",
            createActivity:"Create an activity",
            registrationDetails:"Registration details",
            edit:"Edit",
            activityCode:'Activity Code',
            showProvince:"Registration Province",
            channelGrade:"Number of registrations",
            unlimitedRegistrationQuantity:"Unlimited number of applications",
            signUpBusiness:"Sign up for business",
            eventInformation:"Event Information",
        },
        coupon:{
            couponGroupCode:"Discount group code",
            couponName:"Coupon Name",
            distributionPlatform:"Distribution Platform",
            smallProgram:"Small Program",
            importExcel:"Import Excel",
            addCoupon:"Create Coupons",
            activityCode:"Activity Code",
            activityName:"Activity name",
            denomination:"Denomination",
            RMB:"RMB",
            limitAmount:"Limit amount (yuan)",
            number:"Number",
            employingCounting:"Number of Leads",
            useNumber:"Use number",
            invalidNumber:"void number",
            useTime:"Use time",
            shelfStatus:"Shelf Status",
            couponDenomination:"Coupon Denomination",
            amountLimit:"Amount limit",
            couponNumber:"Coupon Quantity",
            storeRange:"Store Range",
            goodsRange:"Product range",
            receiveTime:"Pick up Time",
            usedTime:"Use time",
            limitReceivedTimes:"Limited number of collars",
            allStores:"All stores",
            registeredStores:"Register Store",
            designatedStores:"Designated stores",
            allGoods:"All Products",
            designatedGoods:"Designated products",
            storeCode:"Store code",
            storeName:"Store Name",
            area:"Area",
            isShelves:'Whether shelves',
            goodsNameGoodscodeSupplier:"Product Name/code/Supplier",
            goodsCatgegory:"Product Categories",
            goodsSKUCode:"Commodity SKU Codes",
            goodsModel:"Product model (SPU)",
            memory:"Memory",
            reasonablePriceRange:"Reasonable price range",
            editCoupon:"Edit Coupons",
            select:"Choose",
            cancelSelect:"Cancel Selection",
            discountGroupCode:"Discount group code",
            getCoupon:"Voucher status",
            couponCode:"Coupon code",
            orderNumber:"Order number",
            consumptionTime:"Consumption time",
            collarPersonnel:"Lead personnel",
            salesNumber:"Sales Tracking Number",
            consumerStores:"Consumer Stores",
            storeCommitmentAmount:"Store Commitment Amount",
            distributionStore:"Issuing merchants",
            viewCoupons:"View Coupons",
            full:'Full',
            yuan:"Yuan",
            isYuan:"Yuan Available",
            importStore:"Import Stores",
            total:"Total",
            home:"Home",
            startReceiveDate:"Pick up Time",
            startUseDate:"Use time",
            isSlef:"Whether shelves",
            choosePlatform:"Choose a release platform!",
            enterCouponName:"Please enter the coupon name!",
            enterContent:"Please input Chinese, digital and English!",
            enterCharactersLess:"Please enter 20 characters or less!",
            chooseStoreRange:"Please select a store range!",
            chooseGoodsRange:"Please select a range of products!",
            pickupNotEmpty:"Pickup start time cannot be empty",
            useNotEmpety:"Use start time cannot be empty",
            delete:'Delete',
            chooseGoods:'Select a product',
            selectStore:"Select a store",
            couponInformation:"Coupon Information",
            couponTemplateUpload:"Coupon Status Import Template upload",
            exportingSmallPrograms:"Exporting to small programs",
            Shelves:"Shelves",
            lowerShelf:"Lower Shelf",
            makeShelves:"Confirm Listing",
            makeLowerShelf:"Confirm the Lower shelf",
            startUseDate:"Use start time",
            endDate:"Use end time",
            alreadyShelves:"Already on shelves",
            alreadyLowerShelf:'has been off the shelf',
            enterCouponDenomination:"Please enter the coupon denomination",
            enterAmountLimit:"Please enter the amount limit",
            enterCouponNumber:"Please enter the number of coupons",
            collectionNotEmpty:"Collection end time cannot be empty",
            endTimeEmpery:"Use end time cannot be empty",
            pleaseLookForward:"Please look forward to!",
            view:"View",
            aduit:"Audit",
            platformCoupons:"Platform Coupons",
            storeCoupons:"Store Coupons"
        }
    },
    merchant:{
        buss:{
            bussCode:'Shopping district Code',
            bussName:'Name of Trade Circle',
            bussLiable:'Head',
            bussDistrict:'Address',
            bussCountryCode:'Countries',
            bussProvinceCode:'Provinces',
            bussCityCode:'City',
            bussZoneCode:'Area',
            bussAdress:'Detailed Address',
            bussType:'Type of Business Circle',
            bussCount:'Number of stores in shopping district',
            bussCapa:'Total capacity of shopping district',
            bussLevel:'Business District Rank',
            bussLongitude:'Business Circle Longitude',
            bussLatitude:'Shopping district Latitude',
            statusCode:'State',
            createdBy:'Create person',
            creationDate:'Creation time',
            lastUpdatedBy:'Operating person',
            lastUpdateDate:'Operating time',
            level:'Level',
            residentPopulation:'District resident population (million persons)',
            bussForm:'Business form of commercial district',
            popularityRankings:'Popularity rankings',
            //new cfg
            addressManagement:"Address Management",
            region:"Regional",
            businessCircleManagement:"Business Circle Management",
            listBusinessDistricts:"List of business districts",
        },
        channel:{
            hours:"Hours",
            automaticCancellationTime:"Automatic Cancellation Time",
            basicInformation:"Basic information",
            terminalImageInformation:"Terminal image Information",
            offlineStore:'Off-line Store',
            partnerThroughShop:'Partner Pass Shop',
            supplyShop:'Supply Store',
            proprietaryShop:'2 C self-store',
            channelCode:'Store code',
            oldChannelCode:'Old Store Code',
            channelName:'Shop Name',
            channelShortName:'Shop abbreviation',
            cooperationChannelType:'Partner Store Type',
            iretailCode:'Iretail encoding',
            accountUuid:'Affiliate UP/W3 Account',
            subjectId:'Affiliate retailer ID',
            subjectName:'Name of affiliated retailer',
            channelGradeCode:'Store Business Form',
            channelSquare:'Total Shop Area',
            channelLiable:'Store owner',
            channelPost:'Post',
            channelLeaseBeginTime:'Store Rental Period Start time',
            channelLeaseEndTime:'Store Rental Period End time',
            channelPhone:'Contact phone',
            channelStartTime:'Business start time',
            channelEndTime:'Business End Time',
            channelTelephone:'Shop Phone',
            channelBusinessDistrict:'Affiliated Shopping district',
            channelBeginTime:'Opening hours',
            channelAddress:'Store Address',
            channelCountryCode:'Countries',
            channelProvinceCode:'Provinces',
            channelCityCode:'City',
            channelZoneCode:'Area',
            channelAddressDetail:'Store Detail Address',
            channelExpiryStartTime:'Store validity:',
            channelExpiryEndTime:'End of store validity',
            channelCounterNum:'Number of input counters',
            channelLampNum:'Number of input light boxes',
            channelPartsNum:'Number of accessory cabinets put into',
            channelCashierNum:'Number of input Registers',
            channelNegotiatingNum:'Number of discussion tables put in',
            channelBackgroundWallNum:'Number of inputs to the background wall',
            channelCultureWallNum:'Number of cultural wall inputs',
            channelGridNum:'Number of iron mesh inputs',
            channelBoutiqueNum:'Number of quality cabinets invested',
            channelContactScreenNum:'Number of input screens',
            channelWindowTvNum:'Number of input window TV',
            channelExamine:'Audit results',
            channelRemarks:'Note',
            channelEnableStatus:'Enable status',
            createdBy:'Create person',
            creationDate:'Creation time',
            lastUpdatedBy:'Last change operator',
            lastUpdateDate:'Last Change time',
            rinanceId:'Association ID',
            consigneeName:'Consignee',
            consigneePhone:'Consignee phone',
            consigneeAddress:'Shipping Address',
            consigneeCountryCode:'Drugstores Address-Country',
            consigneeProvinceCode:'Collect drugstores Address-province',
            consigneeCityCode:'Drugstores Address-City',
            consigneeDistrictCode:'Receive drugstores address-zone',
            consigneeDetail:'Receipt detail Address',
            isDisplayMini:'Whether to show the applet',
            dimension:'Tencent map Latitude',
            longitude:'Tencent map Longitude',
            financeId:'Association ID',
            billType:'Invoice type',
            invoiceTitle:'Invoice Header',
            taxNum:'Tax Identification number',
            registerAddress:'Registered Address',
            registerPhone:'Registered Phone',
            openBank:'Bank Card opening line',
            bankAccount:'Bank card number',
            tradeConfig:'Trading Configuration',
            operation:'Operation',
            operateType:'Type of operation',
            operationResume:'Operation History',
            permanent:'Permanent',
            channelType:'Shop Type',
            auditThrough:'Audit through',
            pendingReview:"Pending review",
            auditNotPassed:'Audit failed',
            registeredAccount:'Registered Account',
            VATFreeInvoice:"VAT Free Text invoice",
            addSpecialInvoice:"Add value to say special invoice",
            generalInvoice:"E-VAT General Invoice",
            tradeImport:"After the order is submitted",
            tradeSuccess:"Trading success",
            goPay:"To pay",
            goStatu:"Enable status",
            PartnerNotEmpty:"Partner Store type cannot be empty",
            storeNotEmpty:"Store name cannot be empty",
            channelCodeNoE:"Store code cannot be empt",
            nameNotEmpety:"The store abbreviation cannot be empty",
            subjectNotEmpety:"The name of the affiliate retailer cannot be empty",
            accountNotEty:"The associated UP/W3 account cannot be empty",
            squareNotEmpety:"The total area of the shop cannot be empty",
            storeBusinessEmpty:'Store business cannot be empty',
            GraderCode:"Area is positive",
            notEmpetyTime:"Store lease start time cannot be empty",
            channelLiableNot:'Store owner cannot be empty',
            postNotEmpety:"The post cannot be empty",
            startNotEmpety:"Business start time cannot be empty",
            phoneNotEmpety:'Contact phone cannot be empty',
            timeNotEmpety:"automatic cancellation time cannot be empty",
            storeExpirationEmpty:"Store expiration start time cannot be empty",
            enterPhone:"Please enter the 11-digit consignee phone!",
            enterContactNumber:"Please enter a 11-digit contact number",
            addressNotEmpety:"Store address cannot be empty",
            beginNotEmpety:"Opening time cannot be empty",
            consigneeNameNot:"The consignee cannot be empty",
            consigneePhoneNot:"The consignee phone cannot be empty",
            addressNoEmpety:"Store delivery address cannot be empty",
            tradeChooseConfig:"Please select trading configuration information",
            transactionConfigurationEmpty:'Transaction configuration information cannot be empty',
            edit:"Edit",
            operationHistory:"Operation History",
            auth:"Audit",
            cancle:"Cancel",
            makeLock:"Confirm Disable",
            confirmEnable:"Confirm Enable",
            alreadyEnable:"is enabled",
            alreadyLock:"is disabled",
            editOfflineStore:"Edit Offline Store",
            operateResume:"Operation History",
            auditOfflineStore:'Audit Offline Store',
            invoiceAddress:"Invoice Address",
            auditFailure:"Audit failure",
            partnerPassShop:"Partner Pass Shop",
            Home:"Home",
            merchantManagement:"Merchant Management",
            storeManagement:"Store Management",
            pmembership:"Affiliated retailer/Supplier",
            head:"Head",
            headPhone:"Contact person",
            validity:"Validity",
            accountBank:"Account Bank",
            account:"Account",
            enableStatus:"Enable status",
            forever:"Permanent",
            financialInformation:"Financial information",
            bankCardNumber:"Bank card number",
            auditOpinion:"Audit opinion" ,
            come:"To",
            newSupplyStore:"New Supply Store",
            editSupplyStore:"Edit Supply Store",
            operateRetailer:"Operation History",
            latitudeLongitudeInformation:"Latitude and longitude information",
            showSmallPrograms:'Show to small programs',
            TencentMap:"Tencent Map:",
            longitude:"Longitude:",
            latitude:"Latitude:",
            queryByLatitude:'Query by latitude',
            storeInformation:'Store information',
            smallProgramShow:"Small program Show",
            paperGeneralInvoice:"Paper General Invoice",
            paperSpecialInvoice:'Paper Special Invoice',
            electronicTextInvoice :"Electronic free text invoice",
            notOpenInvoice :'Do not open the invoice',
        },
        contract:{
            contractCode:"Rontract Code",
            retailerName:"Retailer Name",
            retailerAccountNumber:"Retailer Account Number",
            signatory:"Signatory",
            supplierName:"Supplier Name",
            signingTime:"Signing Time",
            contractInformation:"Contract Information",
            signerEmail:"Signer Email",
            contracContent:"Contrac Content",
            supplierAccountNumber:"Supplier Account Number"
        },
        supplier:{
            supplierCode:'Supplier code',
            supplierName:'Supplier name',
            accountBank:'Account Bank',
            bankAccount:'Account',
            newSupplier:'New Suppliers',
            editSupplier:'Edit Vendor',
            supplierShortName:'Supplier abbreviation',
            supplierAddress:'Supplier address',
            supplierPhone:'Supplier phone',
            receiveInformation:'Goods Receipt Information',
            consignor:'Shipper',
            shipperPhone:'Sender Phone',
            headPhone:'Contact person',
            shipperAddress:'Shipping Address',
            bankNumber:'Bank account Number',
            supplierType:'Supplier Type',
            isEnabled:'is enabled',
            authorizationCompany:'Authorized Certification Company',
            sponsor:'Sponsor',
            honorSponsor:'Honor Sponsor',
            submitter:'By the author.',
            submitTime:'Time of submission',
            statusCode:'Authorization Certificate Audit Status',
            initiatingAuthorizationCertification:'Initiate authorization Certification',
            authorizationCode:'Authorization Code',
            updateFileName:'Vendor Authorization File',
            gatewayProtocol:'Network Signing Protocol',
            submitterDate:'Initiation Time',
            authorizeCertificationSupplier:'Need to authorize certified Supplier',
            authorizedProxy:'Authorized power of Attorney',
            return:'Return',
            initiatingCertification:'Initiating certification',
            uploadDelegationAuthority:'Upload a delegated authorization letter',
            viewDetails:'View Details',
            suppliersOrRetailers:'Supplier/Retailer',
            auditHistory:'Audit history',
            auditAuthorization:'Authorization Letter of approval',
            authorizedCertification:'Authorized Certification',
            honorReviewers:'Honor Reviewers',
            auditTime:'Audit time',
            uploadProxy:'Upload power of Attorney',
            downloadAuthorizationBook:'Download Authorization Form',
            uploadAuthorizationBook:'Upload Authorization Form',
            uploadProtocol:'Upload protocol',
            uploadNetworkProtocol:'Uploading a network signing agreement',
            otherInformation:"Additional Information",
            validity:"Validity",
            shippingAddress:"Shipping Address",
            bankName:"Account name",
            resumeInformationList:'Resume Information List',
            supplierInformation:"Supplier information",
            limitFiles:"Within 2M, you can upload gif, jpg, JPEP, PNG files.",
            certificationDetails:"Certification Details"
        },
        file:{
            uploadFileName:'File',
            uploadFileType:'File type',
            uploadDown:'Upload/download',
            operationPage:'Action page',
            createdBy:'Create person',
            creationDate:'Creation time',
            fileHistory:"File History",
            resumeList:'Resume List',
        },
        retailerManage:{
            retailerAccount:"Retailer Account",//zeng
            retailerCode:"Old Retailer Code",
            retailerName:"Retailer Name",
            contact:"Contact",
            regional:"Regional",
            associationUPW3Number:"Association UP/W3 Number",
            qualificationAuditStatus:"Qualification Audit Status",
            newRetailer:"New Retailer",
            updateRetailer:"Update Retailer",
            operateRetailer:"Operate Retailer",
            exportExcel:"Export Excel",
            typeOfRetailer:"Type Of Retailer",
            country:"Country",
            provinces:"Provinces",
            city:"City",
            enableStatus:"Enable Status",
            operationPerson:"Operation Person",
            whetherHonorKA:"Whether Honor KA",
            totalMonthlySales:"Total Monthly Sales",
            honorMonthSales:"Honor MonthSales",
            contactTitle:"Contact Title",
            localRankings:"Local Rankings",
            contactAddress:"Contact Address",
            destinationStoreAddress:"Destination Store Address",
            storesNumber:"Number of stores operated",
            honorCounterNumber:"Honor Counter Number",
            brandLicensingShop:"Operating brand Licensing Experience Store",
            targetBusinessCircle:"Name of target Trade circle",
            brandExperienceShop:"Brand licensed experience shop in the shopping district",
            businessLicensed:"Upload Business License",
            businessLicense:"Request a template",
            qualificationInformation:"Qualification information",
            basicInformation:"Basic Information",
            registeredCapital:"Registered capital (million yuan)",
            storeNumber:"Stores Number",
            monthlyCapacity:"Monthly Capacity",
            consigneeName:"Consignee Name",
            consigneeTelephone:"Consignee Telephone",
            retailerDeliveryAddress:"Retailer Delivery Address",
            licensingInformation:"Licensing Information",
            businessLicenseName:"Business LicenseName",
            legalRepresentativeID:"Legal Representative ID",
            businessLicenseCode:"Business License Code",
            taxpayerType:"Taxpayer Type",
            taxpayerProof:"Taxpayer Proof",
            accountAuthorization:"Account Authorization Form",
            customerApplicationForm:"Shenzhou Digital Customer Application Form",
            financialInformation:"Financial Information",
            invoiceType:"Invoice Type",
            VATTextInvoice:"VAT Free Text invoice",
            VATSpecialInvoices:"VAT Special Invoices",
            eVATFreetextInvoice:"E-VAT Freetext Invoice",
            invoiceHeader:"Invoice Header",
            taxIdentificationNumber:"Tax Identification Number",
            registeredAddress:"Registered Address",
            registrationTelephone:"Registration Telephone",
            bankCardAccount:"Bank Card Account",
            bankCardNumber:"Bank Card Number",
            auditOpinionArea:"Audit Opinion Area",
            customerClassification:"Customer Classification",
            regionalResponsible:"Regional Responsible",
            retailerBusinessMode:"Retailer BusinessMode",
            retailerOperatorAttribute:"Retailer Operator Attribute",
            retailerAbbreviation:"Retailer Abbreviation",
            retailerLevel:"Retailer Level",
            feneralTaxpayer:"Feneral Taxpayer",
            smallScaleTaxpayer:"Small Scale Taxpayer",
            retailerQualificationAudit:"Retailer Qualification Audit",
            qualificationAudit:"Qualification Audit",
            retailerCertificationAudit:"Retailer Certification Audit",
            AuditResults:"Audit results",
            auditPassed:"Audit through",
            honorRetailerCertification:"Retailer Certification Audit (Honor)",
            digitalRetailerCertification:"Retailer Certification audit (Shen Ma)",
            auditNotPassed:"Audit Not Passed",
            auditCertificationHistory:"Audit Certification History",
            processingLinks:"processing Links",
            processingStatus:"processing Status",
            handlingPeople:"handling People",
            processingTime:"Processing Time",
            supplementaryInformation:"Supplementary Information",
            uploadingDocuments:"Uploading Documents",
            uploadingImages:"Uploading Images",
            approvalLinkCode:"Approval Link Code",
            customerNumber:"Customer Number",
            retailerCodes:"Retailer Code",
            requestTemplateDownload:"Request template Download",
            accountAuthorizationDownload:"Account Authorization Certificate Template download",
            applicationFormDownload:"Application form template Download",
            entryApplicationName:"Please enter the name of the retailer!",
            placeRequire:"Please input Chinese, digital and English!",
            enterEnglish:"Please enter in Chinese and English!",
            enterRegisteredCapital:"Please enter the registered capital!",
            enterPositiveInteger:"Please enter a positive integer!",
            enterPhone:"Please enter the contact number!",
            enterContactNumber:"Please enter a 11-digit contact number!",
            enterStoreNumber:'Please enter the number of stores!',
            enterConsigneeName:"Please enter the consignee's name!",
            enterMonthlyCapacity:"Please enter the monthly capacity!",
            enterConsigneePhone:"Please enter the consignee phone!",
            enterConsigneeTel:"Please enter the 11-digit consignee phone!",
            retailNotEmpety:'The retailer delivery address cannot be empty!',
            enterLicenseName:'Please enter a business license name!',
            enterIDNO:'Please enter the legal Person ID card!',
            enterID:"Please enter 18-digit ID number!",
            enterLicenseCode:"Please enter the business license code!",
            enterTaxpayerCategory:"Please select the taxpayer category!",
            licenseNotEmpety:"The business license cannot be empty!",
            taxpayerNotEmpety:"Taxpayer proof can't be empty!",
            accountNotEmpety:"The account authorization cannot be empty!",
            tableNotEmpety:"Shenzhou Digital Customer Application form cannot be empty!",
            materialAudits:"Material audits",
            siteSurvey:"Site survey",
            regionalPreliminaryExamination:"Regional preliminary examination",
            headquartersReview:"Headquarters review",
            channelCustomerCode:'Customer Code',
            limitUpload:"Within 5M, you can upload doc and docx files.",
            limitClassfiy:"Upload up to 20 sheets, within 2M, to upload PDFs, JPG, PNG files.",
            console:"Console",
            name:"Name",
            retailerInformation:"Retailer Information",
            License:'License',
            personal:"Personal",
            enterprise:"Enterprise",
            depositaryBankName:"Epositary Bank Name",
            invoiceRecipient:"Invoice Recipient",
            recipientAddress:"Recipient Address"
        },
        supplied:{
            subjectName:'Affiliated Supplier name',
            updateFileName:"Authorized power of Attorney",
            uploadAttorney:"Upload power of Attorney",
            aduitFailured:'Audit failed (re-upload power of attorney)',
            rendingUploadProtocol:"Pending Upload Protocol",
            Description:'Description',
            oneRules:"1, by the Honor upload authorization certificate, and designated suppliers to initiate authorization certification.",
            twoRules:" 2, the designated supplier Download authorization certificate, perfect content and stamped with the official seal, re-upload waiting for the Honor audit.",
            thirdRules:"3, honor the approval of the Supplier Upload authorization certificate, through the waiting for the supplier to upload the network signing agreement.",
            fourRules:"4. After the supplier uploads the network signing agreement, the agreement is reached.",
            allMsg:'Please complete the information and cover the official seal after uploading',
        },
    },
    operate:{
        mealOperate:{
            mealType:"Package Type",
            commodityModel:"Main product model",
            source:"Source",
            groupName:"Store group Name",
            combinationRuleName:"Package type name",
            combinationRetailPrice:"Package Retail Price",
            saleableNum:'Packages available for sale in stock',
            skuCode:"Product Code",
            isMainSku:"Whether the main sub-product",
            skuName:"Product Name",
            color:"Color",
            defaultDelivery:"Default Shipping Accessories",
            memory:"Memory",
            networkType:"Network type",
            skuRetailPrice:"Suggested Retail price",
            skuCombinationRule:"Product Package Price",
            qty:"Number",
            supplierName:"Suppliers",
            spuName:"Product Type",
            MainSku:'Main sub-product',
            packageManagement:'Package Management',
            mealCode:"Package code",
            mealName:"Package Name",
            skuMainCode:"Main Commodity SKU Code",
            skuMainName:"Main Commodity SKU Name",
            state:"State",
            retailPrice:"Package price",
            lastUpdatedBy:"Modify People",
            lastUpdateDate:"Modification time",
            remark:"Note",
            newPackage:"New Package",
            modifyPackage:"Modify Package",
            packageDetails:"Package details",
            addModify:"Confirmation Package",
            combinationName:"Store Package Name",
            packageInformation:"Package information",
        },
        mealtype:{
            mealtype:"Type of set meal",
            mainproductModel:"Main commodity model",
            from:"Source",
            shopGroupName:"Shop group name",
            updateBy:"Update By",
            updateTime:"Update Time",
            remark:"Remark",
            create:"Create",
            productModel:"Product Model",
            topCategory: "Top Category",
            secondCategory:"Second Category",
            thirdCategory:"Third Category",
            mainAndViceGoods:"Main and vice goods",
            addProduct:"Add goods",
            deleteProduct:"Delete goods",
            productInformation:"Product Information",
            packageTypeInformation:"Package Type Information",
        }
    },
    operations:{
        commodityManage: "Value added service commodity management",
        create: "create",
        skuGoodsCode:"Sku Goods Code",
        skuGoodsName:"Sku Goods Name",
        commodityCode: "Value-Added Service Commodity Code",
        isMaintained:"Is it maintained",
        commodityProduct: "Value-Added Services products",
        addedService:{
            selectSKUItems:"Select SKU Items",
        },
        advertising:{
            name:"Name" ,
            place:"Position",
            remark:"Notes Information",
            url:"Jump Address",
            imgSrc:"Image",
            htmlStr:"Jump page",
            fundAccountList:"Fund Account List",
            edit:"Edit",
            linkAddress:"Link Address",
            add:"New",
            listAdvertisingOperations:"List of advertising operations",
        },
        commodity:{
            editGoods:"Edit Commodity SKU",
            upperShelf:"Upper Shelf",
            spuCodeL:"Series Product Code",
            spuName:"Product Name",
            productDetails:"Product Details",
            specificationParameter:"Specification parameter",
            packagingAfterSale:"Packaging after-sale",
            PC:"PC version",
            mobileVersion:"Mobile version",
            color:"Color",
            uploadProductImage:"Upload a product image",
            retailPrice:"Guided prices",
            priceScope:"Commodity Pricing Range",
            skuShowName:"Product Display Name",
            merchandising:"Product Promotional language",
            saleableQuantity:"Items available for sale in stock",
            salePrice:"Price",
            statusCode:"State",
            SPUOperationInformation:"SPU Product operation Information",

        },
        notice:{
            noticeCode:"Notice Code",
            noticeTitle:"Notice Title",
            noticeContent:"Notice Content",
            effectiveTime:"Effective Time",
            effectiveStartTime:"Effective Start Time",
            effectiveEndTime:"Effective End Time",
            effectiveStores:"Effective Stores",
            effectiveRange:"Effective Range",
            announcementManagementInformation:"Announcement Management Information",
        }
    },
    commodity:{
        platform:{
            auth:"Product Authorization",
            audit:"Product Review",
            auditStatus:"Audit Status",
            add:"Platform Product creation",
            edit:"Platform Product Modification",
            storesAdd:"Store Product Creation",
            storesEdit:"Store Product Modification",
            name:"Product Name",
            supplier:"Supplier",
            skuCode:"SKU Code",
            spuCode:"SPU Code",
            pushSupplierStatus:"Push Supplier Status",
            levelA:"First Class classification",
            levelB:"Level Two classification",
            levelC:"lLevel Three classification",
            type:"Commodity Type",
            IsSanagement:"Is serial code management",
            source:"Commodity Source",
            spuName:"SPU Name",
            image:"Product pictures",
            retailPrice:"Suggested Retail price",
            maxRetailPrice:"Max Retail Price",
            minRetailPrice:"Min Retail Price",
            color:"Color",
            shopName:"Shop Name",
            shopGroupName:"Shop Group Name",
            resume:"Resume",
            supplyResults:"Material coding pushes supplier results",
            supplyCode:"Vendor Item Code",
            erpCode:"Maintain ERP coding"
        }
    },
    //purchasing
    purchasing:{
        detailedInfo:{
            export:"Export",
            applicationNumber:"Application number",
            skuCode:"Product Code",
            platformSkuName:"Product Name",
            unitPrice:"Supply price",
            applyQty:"Number of applications" ,
            approvalQty:"Number of audits",
            Suppliers:"Suppliers",
            orderDetailedInformation:"Order Detailed information",
        },
        goodsCheck:{
            orderApproval:"Order approval",
            applicationNumber:"Application number",
            retailerName:"Retailer Name",
            processingLinks:"Processing links",
            processingStatus:"Processing status",
            creatTime:"Creation time",
            startTime:"Start time",
            endTime:"End time",
            purchaseRequisition:"Retailer Purchase Requisition",
            storeApplication:"Store Purchase Application",
            applyName:"Application subject",
            applyNameCode:"Apply Name Code",
            applyType:'Application Type',
            createdBy:"Create person",
            detailedInfo:"Tracking Number Details",
            toExamine:'Purchase requisition Form',
            operationResume:"Operation History",
            pendingReview:"Pending review",
            pendingConfirmation:"Pending confirmation",
            auditInformation:'Audit information',
        },
        operationResume:{
            creationDate:"Operating time" ,
            operateDesc:'Operation',
            lastUpdatedBy:"Operating person"
        },
        toExamine:{
            auditOpinion:"Audit opinion" ,
            auditPass:"Audit through",
            auditFail:"Audit does not pass",
            noteMsg:"Notes Information",
            applicationNumber:"Application number",
            skuCode:"Application number",
            platformSkuName:"Product Name",
            unitPrice:"Supply price",
            applyQty:"Number of applications" ,
            approvalQty:"Number of audits",
            Suppliers:"Suppliers",
            applicationSuccess:"Application Form Audit Success!",
            pleaseReconfirm:"The number of audits is all 0, please reconfirm!",
            auditNotEmpety:"The audit does not pass cause cannot be empty!"
        }
    },
    systems:{
        myImportExport:{
            reportName:" Report Name",
            exportFileName:"Export File name",
            templateName:"Template Name",
            noReportEmpety:"Report name cannot be empty",
            noFileEmpety:"The export file name cannot be empty",
            noTemplateEmptey:"Template name cannot be empty",
            importRules:"Import Rules",
            importTemplate:"Import Template",
            checksumFailureCallback:"Checksum failure callback",
            ruleNoEmpety:"Import rule cannot be empty",
            importNoEmpety:"Import template cannot be empty",
            checkCallback:"The checksum failure callback cannot be empty",
            dataCfg:"Data configuration",
            delete:"Delete",
            fileDownload:"File download",
            createCfg:"Create an export configuration",
            modifyExportCfg:"Modify the Export configuration",
            exportDataList:"Export Data List",
            dataService:"Data Services",
            nameTemplateParameter:"Name of template parameter",
            status:"State",
            taskId:"Task ID",
            flie:"Filename",
            exportMessage:"Export messages",
            importMessage:"Import messages",
            startTime:"Start time",
            endTime:"End time",
            importTemplateUp:"Import Template Upload",
            createImportCfg:"Create an Import configuration",
            modifyImportCfg:"Modify the Import configuration",
            importServiceCfg:"Import Service Configuration",
            importFlie:"Import file",
            timeout:"Timeout (milliseconds)",
            maximumNumberRecords:"Maximum number of records",
            exportConfigurationList:"Export Configuration List",
            exportInformation:'Export information',
            flieName:"File name",
            exportDate:"Export Date",
            importInformation:'Import information',
        },
        time:{
            group:'Task Group',
            name:'Task Name',
            cron:'Time-expression',
            status:'State',
            msg:'Note',
            requestUrl:'Micro Service URL',
            createTime:'Creation time',
            createby:'Create person',
            updateTime:'Update Time',
            updateby:'More new',
            addClassList:"Add a class list",
            taskLogQuery:"Task Log Query",
            startTime:"Start time",
            endTime:"End time",
            chooseTime:"Please select time",
            failure:"Failed",
            success:"Success",
            taskConfiguration:"Task configuration",
            modifyingTaskList:"Modify a Task List",
            addTaskList:"Add a Task List",
            taskNoEmpety:"Task Group cannot be empty",
            taskNameEmpety:"Task name cannot be empty",
            serviceNoEmpety:"The micro-service URL cannot be empty",
            statusNoEmpety:"The status cannot be empty",
            test:"Test",
            modify:"Modify",
            delete:"Delete",
            pause:"Time out",
            run:"Run",
            makePause:"Confirm Pause?",
            makeRun:"Confirm Run?",
            cancel:"Cancel",
            taskList:"Task List",
            taskInformation:"Task Information",
            classifyName:"Task class name",
            anExpression:"An Expression",
            news:"News"
        },
        log:{
            group:'Task Group',
            name:'Task Name',
            startTime:'Start time',
            endTime:'End time',
            requestUrl:'Micro Service URL',
            requestTime:'Request time',
            responseTime:'Response time',
            responseStatus:'Response Status Code',
            responseBody:'Response Content',
            errorMsg:'Error message',
            creationDate:'Creation time',
            status:'State'
        },
        international:{
           key1:"Key",
           content:"Content",
           languages:'Languages',
           note:"Note",
           simplified:"Simplified",
           English:"English",
           Traditional:"Traditional",
           createTime:"Creation time",
           updatedDate:"Last Update time",
           total:"Total",
           reviews:"Reviews",
           gridSelf:"Grid personalization Settings",
           gridParams:"Grid parameter settings",
           tips:"Tips",
           noHidden:'The column with the "*" Number cannot be hidden!',
           keyValue:"Key <br> Value"

        },
        lookup:{
            categoryEncoding:"Category encoding",
            categoryName:"Category name",
            addClassList:"Add a class list",
            classEncoding:"Class encoding",
            className:"Class name",
            status:"State",
            categoryNote:"Category notes",
            categoryNoEmpety:"Class encoding cannot be empty",
            nameNoEmpety:"Class name cannot be empty",
            classNoEmpety:"Class cannot be empty",
            lastUpdateDate:"Last Update time",
            itemList:"Item List",
            classInformation:"Class information",
            classList:"Class List",
        },
        lookupItem:{
          lookUpClass:"Lookup View Class",
          lookUpResult:"Lookup Item Query Results",
          itemEncoding:"Item encoding",
          itemDisplayName:"Item Display Name",
          note:'Note',
          status:"Enable",
          sort:"Sort"

        },
        mouldConfig:{
            requestTemplate:"Request a template",
            accountAuthorizationTemplate:"Certificate of Account Authorization proxy template",
            customerApplicationTemplate:"Customer Application form template",
            inventoryImport:"Inventory Import",
            serialCodeImport:"Serial Code Import",
            storeImport:"Store Import",
            retailerImport:"Retailer Import"
        },
        small:{
            appName:'System name',
            groupName:'Module name',
            url:'Service URL',
            remark:'Note',
            createdBy:'Create person',
            creationDate:'Creation time',
            lastUpdatedBy:'Finally more new.',
            lastUpdateDate:'Last Update time',
            authenticationAddressManagement:"Authentication Address Management",
            serviceAddressList:"Service Open Address List",
            modify:"Modify",
            add:"Add",
            serviceAddressManagement:"Service Open Address Management",
        }
    },
    menus:{
        head:{
            configureSystem:"Configure System",
            authManage:"Auth Manage",
            merchantManage:"Merchant Manage",
            inventoryManagement:"Inventory Management",
            userManagement:"User Management",
            memberManagement:"Member Management",
            marketingManage:"Marketing Manage",
            financialManagement:"Financial Management",
            commodityManagement:"Commodity Management",
            operationsManagement:'Operations Management',
            procurementManagement:"Procurement Management",
            transactionManagement:"Transaction Management",
            systemManagement:"System Management",
            systemStorage :"Storage System"
        },
        left:{
            activityManagement:"Activity Management",
            BasicInformationManagement:"Basic information management",
            contractManagement:"Contract Management",
            afterSalesManagement:"After Sales Management",
            refundSlipManagement:"Refund Slip Management",
            authorizeManage:"Authorize Manage",
            roleManage:"Role Manage",
            dataScopeManage:"Data Scope Manage",
            groupManage:"Group Manage",
            noticeManage:"Notice Manage",
            platformCommodity:"Platform Commodity",
            dimensionManage:"Dimension Manage",
            mealtypeOperate:"Mealtype Operate",
            retailerManage:"Retailer Manage",
            supplierManage:"Supplier Manage",
            couponManagePlatform:"Coupon Manage (Platform)",
            couponManageStore:"Coupon Manage (Store)",
            myProfile:"My Profile",
            todoItems:"Todo Items",
            accountList2B:"2B Account List ",
            accountList2C:"2C Account List ",
            levelManagement:"Level Management",
            storeManagement:"Store Management",
            offLineStore:"off-line Store",
            supplyStore:"Supply Store",
            businessAddressManagement:" Business Circle Address Management",
            businessCircleManagement:"Business Circle Management",
            supplierManagement:"Supplier management",
            authorizedCertificationManage:"Authorized Certification",
            authorizedCertification:"Authorized Certification (Honer)",
            authorizedCertificationSupplier:"Authorized certification (Supplier/Divine Code)",
            fileManagement:"File Management",
            fileHistory:"File history",
            basicConfiguration:'Basic Configuration',
            invoiceConfiguration:"Invoice configuration",
            paymentConfiguration :"Payment Configuration",
            fundAccountManagement:'Fund Account Management',
            fundAccountList:'Fund Account List',
            clientFundManagement:'Client account fund management',
            ICBCAccount :'Customer ICBC Account',
            incentiveManagement:'Incentive Management',
            balanceFundsAccount:'Balance sheet of funds in account',
            platformProductsManagement:'Platform Products Management',
            supplierProductManagement:'Supplier Product Management',
            storeGoodsSelect:"Store goods Select",
            storeGoods:'Store goods',
            commodityBaseManagement:'Commodity Base Management',
            productCategoriesManagement :"Product Categories Management",
            propertyConfigurationManagement:"Property configuration Management",
            propertyConfiguration :'Property configuration',
            classificationRelationshipMaintenance:'Classification and attribute relationship maintenance',
            SPUCommodityOperations :'SPU Commodity Operations',
            SPUCommodityManagement:"SPU Commodity Management",
            commodityOperation:'Commodity value-added service operation',
            announcementManagement :'Announcement Management',
            orderApproval:'Order approval',
            outOfManagement:'Out-of-storage management',
            warehousingManagement:'Warehousing Management',
            outLibraryManagement:'Out-of-Library management',
            inventoryManagement:'Inventory Management',
            inventoryInquiry:'Inventory Inquiry',
            queryCode:'Query in library string code',
            stockSnapshot:'Stock Snapshot',
            serialRecords:'Serial code out of storage records',
            storeOrderManagement:'Store Retail Order Management',
            vendorOrderManagement:'Vendor Sales Order Management',
            refundManagement:'Refund Management',
            orderPushMonitoring:'Order Push Monitoring',
            pushMonitoringConfiguration:'Push monitoring Configuration',
            couponManagement:'Coupon Management',
            marketingActivities:"Marketing Activities",
            dimensionManagement:'Dimension Management',
            internationalInformationManagement:'International Information Management',
            lookupManagement:'Lookup Management',
            myImportExport:'My Import and Export',
            exportQuery:'Export query',
            importQuery:'Import Query',
            importConfiguration:'Import configuration',
            exportConfiguration:'Export configuration',
            scheduledTasks:'Scheduled Tasks',
            taskConfiguration:'Task configuration',
            taskLogQuery:'Task Log Query',
            templateConfiguration:'Template configuration',
            commodityAdvertisingManagement:"Commodity advertising Management",
            smallProgramGateway:"Small program Gateway",
            serviceOpenAddress:"Service Open Address",
            refundRecordQuery:"Refund Record Query",
            orderRefundRecord:"Retail Order refund Record query",
            orderManagement:"Store Reservation Order Management",
            aftersalesManagement:'After-sales management',
            managementSMS:"短信推送管理"
        }
    },
    //user
    user:{
        mydata:{
            account:"Account",
            userType:"User type",
            name:"Name",
            contactPhone:"Contact phone" ,
            email:"E-Mail" ,
            QQ:"QQ",
            wechat:"Wechat"
        },
        retailerNews:{
            mydata:"My profile",
            status:"State",
            retailerCodes:"Retailer Code",
            retailerName:"Retailer Name",
            retailerAccount:"Retailer Account",
            businessLicenseCode:"Business license Code",
            province:"Provinces",
            city:"City",
        },
        todo:{
            retailerCertificationApplication:"Retailer Certification Application",
            retailerRequestGoods:"Retailer Request for goods",
            storeRegistrationApplication:"Store Registration Application",
            applicationStoreOccupancy:"Application for Store occupancy",
            China:"China",
            all:'All',
            pendingReview:'Pending review'
        },
        accountB:{
            accountUuid:"Affiliate UP/W3 Account",
            name:"name",
            phone:"Contact phone",
            code:"User Principal",
            subjectName:"Principal Name",
            post:"Post",
            country:"Country",
            province:"Province",
            city:"City",
            zone:"Area",
            contactAddress:"Detailed Address",
            status:"Status",
            accountListInformation:"Account List Information"
        },
        accountC:{
            userId:'User ID',
            type:'User type',
            employeeNumber:'Account',
            displayname:'Name of contact person',
            phone:'Contact phone number',
            uuid:'Encrypt account information',
            departmentNumber:'Department number',
            departmentName:'Department Name',
            departmentNameEn:'Name of department in English',
            displayNameEn:'English name',
            email:'Contact Mailbox',
            lastUpdateDate:'Last logon time',
            creationDate:'Creation time',
            employeetype:'Third-party user types',
            appTYPE:'SOURCE Application',
            reservationInformation:"Reservation Information",
            shippingAddressInformation:"Shipping Address Information",
            invoiceInformation:"Invoice information",

            consigneeName:'Consignee',
            consigneePhone:'Consignee phone',
            consigneeCountryCode:'Country of receiving goods',
            consigneeProvinceCode:'Goods receiving province',
            consigneeCityCode:'Goods receiving city',
            consigneeDistrictCode:'Goods receiving Area',
            consigneeDetail:'Detailed delivery address',
            isDefault:'Whether the default',
            beUserName:"Reservation person",
            beUserPhone:"Phone",
            provinceId:"Goods receiving province",
            cityId:"Goods receiving city",
            regionId:"Harvest Counties",
            address:"Detailed delivery address",

            billType:'Invoice type',
            invoiceTitle:'Invoice Header',
            invoiceTitleType:'Invoice Header Type',
            taxNum:'Tax Identification number',
            isOpenTicket:'Whether to invoice by default',

            userName:'Reservation person',
            detailQuery:"Detail Query",

        }
    }
}


// WEBPACK FOOTER //
// ./src/locale/en-US.js